import { styled } from '@linaria/react'

export const SettingsNestedPageTextBlockSC = styled.div`
  display: block;
  width: 100%;
`
